import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetUserProfilePictureRequest = {
	userId: number;
};

export const getUserProfilePicture = createGetEndpoint<GetUserProfilePictureRequest, Blob>(
	(request) => `/api/v3/core/users/${request.userId}/profile-picture`,
	{
		responseIsBlob: true
	}
);
